const developmentConfig = {
  ENV: 'development'
}

export default developmentConfig
